<template>
	<v-container fluid>
		<v-container>
			<v-card>
                <v-card-title>{{ $t('gdpr.title') }}</v-card-title>
                <v-card-subtitle>{{ $t('gdpr.subtitle') }}</v-card-subtitle>
                <v-card-text class="kktin" v-html="gdpr_html.content">
                </v-card-text>
            </v-card>
		</v-container>
	</v-container>
</template>

<script>
import ApiService from "@/services/api_service";

export default {
  name: 'Gdpr',
  data() {
    return {
      gdpr_html: {},
    }
  },
  mounted() {
    ApiService.get(`/gdpr`).then((response) => {
      this.gdpr_html = response.data;
    }).catch(() => {});
  },
};
</script>
<style scoped>
.kktin {
    text-align: justify;
}
</style>
